module.exports = __webpack_public_path__ + "static/media/step-01.28996b33.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-card-calf/img/step-01.png
 ** module id = 2059
 ** module chunks = 0
 **/